import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import styles from './ProjectCreateContent.module.scss'
import {
  CustomCol, GoBackLink, ProjectFormStepSlider,
  CustomTitle, CustomCard, ProjectForm
} from 'src/components'

const ProjectCreateContent: React.FC = () => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return (
    <div className='fade-animation'>
      <Row className={styles.contentMargin}>
        <CustomCol className={isMobile && styles.mobileView}>
          <GoBackLink link={'/my-projects'} />
          <CustomTitle label={t('Projects.CreateProject')} level={4} />
        </CustomCol>
        <CustomCol>
          <div className='float-right'>
            <ProjectFormStepSlider />
          </div>
        </CustomCol>
      </Row>

      <CustomCard className={styles.contentMargin}>
        <ProjectForm />
      </CustomCard>
    </div>
  )
}

export default ProjectCreateContent
